import React from 'react';
import useTranslation from '../../../../../../hooks/translation/useTranslation';

function PaymentCard({ data, handleDelete }) {
  const { trans } = useTranslation();
  return (
    <div className="flex gap-4 items-center justify-between max-w-[500px]">
      <div className="flex gap-4 items-center">
        <div className="w-[35px] h-[25px] bg-[#1834CD] rounded-[4px]" />
        {data?.mask}
      </div>
      <button
        type="button"
        className="text-primary bg-transparent border-none font-big-bold cursor-pointer text-base"
        onClick={() => handleDelete(data.id)}
      >
        {trans('delete')}
      </button>
    </div>
  );
}

export default PaymentCard;
